export default __webpack_public_path__ + "static/media/manifestationofspirit.2a10e861.png";